// Describes and logs failed GraphQL queries so a browser console or a screenshot of the page says
// what failed: the server, the HTTP layer or the network, and after how long.

export interface IQueryFailure {
  kind: 'server' | 'http' | 'network' | 'unknown';
  status: number | null;
  messages: string[];
  elapsedMs: number;
  at: string;
}

export const describeFailure = (error: any, startedAt: number): IQueryFailure => {
  const graphQLErrors: any[] = (error && error.graphQLErrors) || [];
  const networkError: any = (error && error.networkError) || null;
  const status: number | null =
    networkError && typeof networkError.statusCode === 'number' ? networkError.statusCode : null;

  let kind: IQueryFailure['kind'] = 'unknown';
  let messages: string[] = [];
  if (graphQLErrors.length) {
    kind = 'server';
    messages = graphQLErrors.map((e) => e.message);
  } else if (status !== null) {
    kind = 'http';
    messages = [networkError.message];
  } else if (networkError) {
    kind = 'network';
    messages = [networkError.message];
  } else if (error) {
    messages = [error.message || String(error)];
  }

  return {
    kind,
    status,
    messages,
    elapsedMs: Date.now() - startedAt,
    at: new Date().toISOString(),
  };
};

// One line for the page, e.g. "Server error after 30.1 s at 2026-10-07T19:41:03.120Z".
export const failureSummary = (failure: IQueryFailure): string => {
  const what = {
    server: 'Server error',
    http: `HTTP ${failure.status}`,
    network: 'No response from the server',
    unknown: 'Unexpected error',
  }[failure.kind];
  return `${what} after ${(failure.elapsedMs / 1000).toFixed(1)} s at ${failure.at}`;
};

export const logQueryFailure = (query: string, context: object, failure: IQueryFailure): void => {
  // tslint:disable-next-line:no-console
  console.error(`[${query}] failed: ${failureSummary(failure)}`, { ...context, ...failure });
};

export const logQueryResult = (query: string, context: object, rows: number, startedAt: number): void => {
  // tslint:disable-next-line:no-console
  console.info(`[${query}] ${rows} rows in ${Date.now() - startedAt} ms`, context);
};
